import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { fetchThreatDownEndpoint } from '@/api/threatdown'
import { ThreatDownDetailView } from '@/components/threatdown/ThreatDownDetailView'
import { ThreatDownNav } from '@/components/threatdown/ThreatDownNav'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { formatDateTime } from '@/lib/formatAgent'

export function ThreatDownEndpointDetail() {
  const { id } = useParams()
  const [endpoint, setEndpoint] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    setLoading(true)
    setError('')
    fetchThreatDownEndpoint(id)
      .then(setEndpoint)
      .catch((err) => {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Could not load ThreatDown endpoint.')
      })
      .finally(() => setLoading(false))
  }, [id])

  if (loading) return <Skeleton className="h-96 w-full" />

  return (
    <div className="space-y-6">
      <ThreatDownNav />

      <Button variant="ghost" size="sm" asChild>
        <Link to="/threatdown">
          <ArrowLeft className="h-4 w-4" />
          Back to endpoints
        </Link>
      </Button>

      {error ? (
        <p className="text-destructive">{error}</p>
      ) : (
        <>
          {endpoint?.synced_at && (
            <p className="text-sm text-muted-foreground">
              Last synced {formatDateTime(endpoint.synced_at)}
              {endpoint.engine_version ? ` · Engine ${endpoint.engine_version}` : ''}
            </p>
          )}
          <ThreatDownDetailView endpoint={endpoint} />
        </>
      )}
    </div>
  )
}
